import React from 'react';
import cx from 'classnames';
import { ImageIcon } from '@move-ui/icons-asset-catalog';
import styles from './ImageBadge.module.css';
const ImageBadge = ({ className, label }) => (React.createElement("span", { className: cx(styles.component, className) },
    React.createElement(ImageIcon, { "data-testid": "ImageIcon", className: styles.icon }),
    label));
export default ImageBadge;
//# sourceMappingURL=ImageBadge.js.map